import CustomImageInput from "./CustomImageInput";

const PrivateCustomImageInput = ({
  isDisable,
  setIsDisable,
  label,
  SubCategoryId,
  setDataId,
  isRequired = false,
  source,
  name,
  isMulty = false,
  isValidate = false,
  helperText = null,
}) => {
  return (
    <CustomImageInput
      source={source}
      name={name}
      helperText={helperText}
      isDisable={isDisable}
      setIsDisable={setIsDisable}
      label={label}
      isRequired={isRequired}
      SubCategoryId={SubCategoryId}
      isValidate={isValidate}
      isMulty={isMulty}
      setDataId={setDataId}
      resource={"document/private-documents"}
    />
  );
};
export default PrivateCustomImageInput;
